/*
 * Jira Ticket:
 * Created Date: Thu, 4th Jun 2020, 09:54:10 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneSubscriptionTierQuery = gql`
  query SubscriptionTier($id: ID!) {
    data: SubscriptionTier(id: $id) {
      id
      name
      monthlyPlan {
        cost {
          currencyCode
          amount
        }
      }
      annualPlan {
        cost {
          currencyCode
          amount
        }
      }
      isFreeTier
      isCustomTier
      isInitialTier
      customOrganisationsIds
      freeTrialDuration
      maximumEmployees
      maximumSubcontractors
      maximumProjects
      capabilities {
        id
        description
        enabled
      }
      statistics {
        monthlySubscribers
        annualSubscribers
      }
    }
  }
`;
